import request from '@services/request';

const getNotificationsByHash = async (hashId) => {
  const params = {
    hash_id: hashId,
  };
  const result = await request.get('/api/v1/corresponsal/notificationsByTransfer', params);
  const { data } = result;
  return data;
};

const sendNotification = async (channel, content, receiver, hashId) => {
  const body = {
    channel,
    content,
    receiver,
    hash_id: hashId,
  };
  const result = await request.post('/api/v1/corresponsal/notifications', body);
  const { data } = result;
  return data;
};

export { getNotificationsByHash, sendNotification };
